import * as z from "zod";

export const submitMerchantFeedbackFollowUp = {
  name: "submitMerchantFeedbackFollowUp" as const,
  input: z.object({
    // The feedbackId returned from submitMerchantFeedback.
    feedbackId: z.string().min(1),
    // The merchant's answer to the follow-up question. Omit (or leave empty)
    // when the merchant skips the question — the Slack notification still
    // fires, just without an answer.
    answer: z.string().trim().max(1000).optional(),
  }),
  output: z.object({ success: z.literal(true) }),
};
